import { action, makeAutoObservable } from "mobx";
import moment from "moment";

export class FilterStore {
  parent: any;

  notReset: string[] = [];
  showPeriod = true;
  showSearchBtn = true;
  showResetBtn = true;
  periodLabel = "Period";

  constructor(store: any) {
    makeAutoObservable(this, {
      parent: false,
    });
    this.parent = store;
  }

  @action onPeriod(value) {
    this.parent.filter.period = value;
  }

  @action onSearch(history) {
    let period: string[] = [];
    if (this.parent.filter.period?.[0]) {
      period = [
        moment(this.parent.filter.period?.[0]).format("YYYY-MM-DD"),
        moment(this.parent.filter.period?.[1]).format("YYYY-MM-DD"),
      ];
    }
    const query = new URLSearchParams({ ...this.parent.filter, period, page: 1 });
    history.push({ search: query.toString() });
  }

  @action onPage(history, page, pageSize) {
    const query = new URLSearchParams({ ...this.parent.filter, page, pageSize });
    history.push({ search: query.toString() });
  }

  @action onReset(history) {
    let obj = {};
    this.notReset.map((x) => {
      obj[x] = this.parent.filter[x];
    });
    const query = new URLSearchParams(obj);
    history.push({ search: query.toString() });
  }

  @action refresh() {
    this.parent.refresh();
  }
}
